import { render, staticRenderFns } from "./IntroCEO.vue?vue&type=template&id=d130d116&scoped=true"
import script from "./IntroCEO.vue?vue&type=script&lang=js"
export * from "./IntroCEO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d130d116",
  null
  
)

export default component.exports